 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"account.index~admin.banner~admin.exchange.index~admin.exchange.vehicle.edit~admin.merchant~admin.mer~cfe31147":"account.index~admin.banner~admin.exchange.index~admin.exchange.vehicle.edit~admin.merchant~admin.mer~cfe31147","account.index~admin.exchange.vehicle.edit~admin.merchant.create~admin.settings~cart.index~login~pass~438020be":"account.index~admin.exchange.vehicle.edit~admin.merchant.create~admin.settings~cart.index~login~pass~438020be","account.index":"account.index","admin.dashboard~admin.exchange.vehicle.edit~admin.order.details~vehicle.details~vehicle.index":"admin.dashboard~admin.exchange.vehicle.edit~admin.order.details~vehicle.details~vehicle.index","admin.exchange.vehicle.edit":"admin.exchange.vehicle.edit","admin.merchant.create":"admin.merchant.create","admin.settings":"admin.settings","password-reset":"password-reset","admin.banner":"admin.banner","admin.dashboard~admin.exchange.index~admin.merchant~admin.orders~exchange.index~vehicle.index":"admin.dashboard~admin.exchange.index~admin.merchant~admin.orders~exchange.index~vehicle.index","admin.merchant":"admin.merchant","cart.index":"cart.index","vehicle.index":"vehicle.index","admin.exchange.index":"admin.exchange.index","admin.orders":"admin.orders","exchange.index":"exchange.index","admin.order.details":"admin.order.details","vehicle.details":"vehicle.details","admin.merchant.details":"admin.merchant.details","offer.index":"offer.index","settings.index":"settings.index","surcharge.index":"surcharge.index","login":"login","admin.dashboard":"admin.dashboard","admin.offers":"admin.offers","order.index":"order.index","faq.index":"faq.index"}[chunkId]||chunkId) + "." + {"account.index~admin.banner~admin.exchange.index~admin.exchange.vehicle.edit~admin.merchant~admin.mer~cfe31147":"0a13aeeb","account.index~admin.exchange.vehicle.edit~admin.merchant.create~admin.settings~cart.index~login~pass~438020be":"fd8773a0","account.index":"645432ef","admin.dashboard~admin.exchange.vehicle.edit~admin.order.details~vehicle.details~vehicle.index":"9b127699","admin.exchange.vehicle.edit":"4b79b4d4","admin.merchant.create":"0d040d95","admin.settings":"a91eff67","password-reset":"8cf0be36","admin.banner":"6de7130d","admin.dashboard~admin.exchange.index~admin.merchant~admin.orders~exchange.index~vehicle.index":"4000c00b","admin.merchant":"86373bde","chunk-ea63df68":"f96e9848","cart.index":"b3d365e0","vehicle.index":"cc037ce0","admin.exchange.index":"9fba8308","admin.orders":"c0ee0fc6","exchange.index":"ff6ef8b0","admin.order.details":"8326e7aa","vehicle.details":"666bf331","admin.merchant.details":"5efb0c37","offer.index":"58464bc6","settings.index":"44073a80","surcharge.index":"b7a01a13","login":"f7b3d4e2","chunk-2d0aba49":"53350a23","chunk-2d0aef09":"91d3b180","chunk-2d0b6d36":"cb8fd956","chunk-2d0c15a6":"360bcc77","chunk-2d21f080":"e428ea4f","chunk-34b0f10b":"a2d7f811","admin.dashboard":"5b621daf","admin.offers":"97aa34f1","chunk-d0a5c64e":"6f0edc48","order.index":"11a16046","faq.index":"3df4cc2a","chunk-1d06b929":"06fe1043","chunk-2d0b365a":"a9bdbdf4","chunk-4b126c83":"2e2c1587","chunk-2d2109ec":"159ff9cf","chunk-c2340dae":"9162fa6c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"account.index~admin.banner~admin.exchange.index~admin.exchange.vehicle.edit~admin.merchant~admin.mer~cfe31147":1,"admin.settings":1,"vehicle.index":1,"admin.order.details":1,"chunk-1d06b929":1,"chunk-4b126c83":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"account.index~admin.banner~admin.exchange.index~admin.exchange.vehicle.edit~admin.merchant~admin.mer~cfe31147":"account.index~admin.banner~admin.exchange.index~admin.exchange.vehicle.edit~admin.merchant~admin.mer~cfe31147","account.index~admin.exchange.vehicle.edit~admin.merchant.create~admin.settings~cart.index~login~pass~438020be":"account.index~admin.exchange.vehicle.edit~admin.merchant.create~admin.settings~cart.index~login~pass~438020be","account.index":"account.index","admin.dashboard~admin.exchange.vehicle.edit~admin.order.details~vehicle.details~vehicle.index":"admin.dashboard~admin.exchange.vehicle.edit~admin.order.details~vehicle.details~vehicle.index","admin.exchange.vehicle.edit":"admin.exchange.vehicle.edit","admin.merchant.create":"admin.merchant.create","admin.settings":"admin.settings","password-reset":"password-reset","admin.banner":"admin.banner","admin.dashboard~admin.exchange.index~admin.merchant~admin.orders~exchange.index~vehicle.index":"admin.dashboard~admin.exchange.index~admin.merchant~admin.orders~exchange.index~vehicle.index","admin.merchant":"admin.merchant","cart.index":"cart.index","vehicle.index":"vehicle.index","admin.exchange.index":"admin.exchange.index","admin.orders":"admin.orders","exchange.index":"exchange.index","admin.order.details":"admin.order.details","vehicle.details":"vehicle.details","admin.merchant.details":"admin.merchant.details","offer.index":"offer.index","settings.index":"settings.index","surcharge.index":"surcharge.index","login":"login","admin.dashboard":"admin.dashboard","admin.offers":"admin.offers","order.index":"order.index","faq.index":"faq.index"}[chunkId]||chunkId) + "." + {"account.index~admin.banner~admin.exchange.index~admin.exchange.vehicle.edit~admin.merchant~admin.mer~cfe31147":"5bf68eb5","account.index~admin.exchange.vehicle.edit~admin.merchant.create~admin.settings~cart.index~login~pass~438020be":"31d6cfe0","account.index":"31d6cfe0","admin.dashboard~admin.exchange.vehicle.edit~admin.order.details~vehicle.details~vehicle.index":"31d6cfe0","admin.exchange.vehicle.edit":"31d6cfe0","admin.merchant.create":"31d6cfe0","admin.settings":"525acc37","password-reset":"31d6cfe0","admin.banner":"31d6cfe0","admin.dashboard~admin.exchange.index~admin.merchant~admin.orders~exchange.index~vehicle.index":"31d6cfe0","admin.merchant":"31d6cfe0","chunk-ea63df68":"31d6cfe0","cart.index":"31d6cfe0","vehicle.index":"38b0338e","admin.exchange.index":"31d6cfe0","admin.orders":"31d6cfe0","exchange.index":"31d6cfe0","admin.order.details":"19087de7","vehicle.details":"31d6cfe0","admin.merchant.details":"31d6cfe0","offer.index":"31d6cfe0","settings.index":"31d6cfe0","surcharge.index":"31d6cfe0","login":"31d6cfe0","chunk-2d0aba49":"31d6cfe0","chunk-2d0aef09":"31d6cfe0","chunk-2d0b6d36":"31d6cfe0","chunk-2d0c15a6":"31d6cfe0","chunk-2d21f080":"31d6cfe0","chunk-34b0f10b":"31d6cfe0","admin.dashboard":"31d6cfe0","admin.offers":"31d6cfe0","chunk-d0a5c64e":"31d6cfe0","order.index":"31d6cfe0","faq.index":"31d6cfe0","chunk-1d06b929":"ecf0bfe7","chunk-2d0b365a":"31d6cfe0","chunk-4b126c83":"e2c54dba","chunk-2d2109ec":"31d6cfe0","chunk-c2340dae":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
